/*! sticky-sidebar - v3.3.1 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e(t.StickySidebar={})}(this,function(t){"use strict";"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;var e,i,n=(function(t,e){(function(t){Object.defineProperty(t,"__esModule",{value:!0});var l,n,e=function(){function n(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(t,e,i){return e&&n(t.prototype,e),i&&n(t,i),t}}(),i=(l=".stickySidebar",n={topSpacing:0,bottomSpacing:0,containerSelector:!1,innerWrapperSelector:".inner-wrapper-sticky",stickyClass:"is-affixed",resizeSensor:!0,minWidth:!1},function(){function c(t){var e=this,i=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),this.options=c.extend(n,i),this.sidebar="string"==typeof t?document.querySelector(t):t,void 0===this.sidebar)throw new Error("There is no specific sidebar element.");this.sidebarInner=!1,this.container=this.sidebar.parentElement,this.affixedType="STATIC",this.direction="down",this.support={transform:!1,transform3d:!1},this._initialized=!1,this._reStyle=!1,this._breakpoint=!1,this.dimensions={translateY:0,maxTranslateY:0,topSpacing:0,lastTopSpacing:0,bottomSpacing:0,lastBottomSpacing:0,sidebarHeight:0,sidebarWidth:0,containerTop:0,containerHeight:0,viewportHeight:0,viewportTop:0,lastViewportTop:0},["handleEvent"].forEach(function(t){e[t]=e[t].bind(e)}),this.initialize()}return e(c,[{key:"initialize",value:function(){var i=this;if(this._setSupportFeatures(),this.options.innerWrapperSelector&&(this.sidebarInner=this.sidebar.querySelector(this.options.innerWrapperSelector),null===this.sidebarInner&&(this.sidebarInner=!1)),!this.sidebarInner){var t=document.createElement("div");for(t.setAttribute("class","inner-wrapper-sticky"),this.sidebar.appendChild(t);this.sidebar.firstChild!=t;)t.appendChild(this.sidebar.firstChild);this.sidebarInner=this.sidebar.querySelector(".inner-wrapper-sticky")}if(this.options.containerSelector){var e=document.querySelectorAll(this.options.containerSelector);if((e=Array.prototype.slice.call(e)).forEach(function(t,e){t.contains(i.sidebar)&&(i.container=t)}),!e.length)throw new Error("The container does not contains on the sidebar.")}"function"!=typeof this.options.topSpacing&&(this.options.topSpacing=parseInt(this.options.topSpacing)||0),"function"!=typeof this.options.bottomSpacing&&(this.options.bottomSpacing=parseInt(this.options.bottomSpacing)||0),this._widthBreakpoint(),this.calcDimensions(),this.stickyPosition(),this.bindEvents(),this._initialized=!0}},{key:"bindEvents",value:function(){window.addEventListener("resize",this,{passive:!0,capture:!1}),window.addEventListener("scroll",this,{passive:!0,capture:!1}),this.sidebar.addEventListener("update"+l,this),this.options.resizeSensor&&"undefined"!=typeof ResizeSensor&&(new ResizeSensor(this.sidebarInner,this.handleEvent),new ResizeSensor(this.container,this.handleEvent))}},{key:"handleEvent",value:function(t){this.updateSticky(t)}},{key:"calcDimensions",value:function(){if(!this._breakpoint){var t=this.dimensions;t.containerTop=c.offsetRelative(this.container).top,t.containerHeight=this.container.clientHeight,t.containerBottom=t.containerTop+t.containerHeight,t.sidebarHeight=this.sidebarInner.offsetHeight,t.sidebarWidth=this.sidebarInner.offsetWidth,t.viewportHeight=window.innerHeight,t.maxTranslateY=t.containerHeight-t.sidebarHeight,this._calcDimensionsWithScroll()}}},{key:"_calcDimensionsWithScroll",value:function(){var t=this.dimensions;t.sidebarLeft=c.offsetRelative(this.sidebar).left,t.viewportTop=document.documentElement.scrollTop||document.body.scrollTop,t.viewportBottom=t.viewportTop+t.viewportHeight,t.viewportLeft=document.documentElement.scrollLeft||document.body.scrollLeft,t.topSpacing=this.options.topSpacing,t.bottomSpacing=this.options.bottomSpacing,"function"==typeof t.topSpacing&&(t.topSpacing=parseInt(t.topSpacing(this.sidebar))||0),"function"==typeof t.bottomSpacing&&(t.bottomSpacing=parseInt(t.bottomSpacing(this.sidebar))||0),"VIEWPORT-TOP"===this.affixedType?t.topSpacing<t.lastTopSpacing&&(t.translateY+=t.lastTopSpacing-t.topSpacing,this._reStyle=!0):"VIEWPORT-BOTTOM"===this.affixedType&&t.bottomSpacing<t.lastBottomSpacing&&(t.translateY+=t.lastBottomSpacing-t.bottomSpacing,this._reStyle=!0),t.lastTopSpacing=t.topSpacing,t.lastBottomSpacing=t.bottomSpacing}},{key:"isSidebarFitsViewport",value:function(){var t=this.dimensions,e="down"===this.scrollDirection?t.lastBottomSpacing:t.lastTopSpacing;return this.dimensions.sidebarHeight+e<this.dimensions.viewportHeight}},{key:"observeScrollDir",value:function(){var t=this.dimensions;if(t.lastViewportTop!==t.viewportTop){var e="down"===this.direction?Math.min:Math.max;t.viewportTop===e(t.viewportTop,t.lastViewportTop)&&(this.direction="down"===this.direction?"up":"down")}}},{key:"getAffixType",value:function(){this._calcDimensionsWithScroll();var t=this.dimensions,e=t.viewportTop+t.topSpacing,i=this.affixedType;return e<=t.containerTop||t.containerHeight<=t.sidebarHeight?(t.translateY=0,i="STATIC"):i="up"===this.direction?this._getAffixTypeScrollingUp():this._getAffixTypeScrollingDown(),t.translateY=Math.max(0,t.translateY),t.translateY=Math.min(t.containerHeight,t.translateY),t.translateY=Math.round(t.translateY),t.lastViewportTop=t.viewportTop,i}},{key:"_getAffixTypeScrollingDown",value:function(){var t=this.dimensions,e=t.sidebarHeight+t.containerTop,i=t.viewportTop+t.topSpacing,n=t.viewportBottom-t.bottomSpacing,o=this.affixedType;return this.isSidebarFitsViewport()?t.sidebarHeight+i>=t.containerBottom?(t.translateY=t.containerBottom-e,o="CONTAINER-BOTTOM"):i>=t.containerTop&&(t.translateY=i-t.containerTop,o="VIEWPORT-TOP"):t.containerBottom<=n?(t.translateY=t.containerBottom-e,o="CONTAINER-BOTTOM"):e+t.translateY<=n?(t.translateY=n-e,o="VIEWPORT-BOTTOM"):t.containerTop+t.translateY<=i&&0!==t.translateY&&t.maxTranslateY!==t.translateY&&(o="VIEWPORT-UNBOTTOM"),o}},{key:"_getAffixTypeScrollingUp",value:function(){var t=this.dimensions,e=t.sidebarHeight+t.containerTop,i=t.viewportTop+t.topSpacing,n=t.viewportBottom-t.bottomSpacing,o=this.affixedType;return i<=t.translateY+t.containerTop?(t.translateY=i-t.containerTop,o="VIEWPORT-TOP"):t.containerBottom<=n?(t.translateY=t.containerBottom-e,o="CONTAINER-BOTTOM"):this.isSidebarFitsViewport()||t.containerTop<=i&&0!==t.translateY&&t.maxTranslateY!==t.translateY&&(o="VIEWPORT-UNBOTTOM"),o}},{key:"_getStyle",value:function(t){if(void 0!==t){var e={inner:{},outer:{}},i=this.dimensions;switch(t){case"VIEWPORT-TOP":e.inner={position:"fixed",top:i.topSpacing,left:i.sidebarLeft-i.viewportLeft,width:i.sidebarWidth};break;case"VIEWPORT-BOTTOM":e.inner={position:"fixed",top:"auto",left:i.sidebarLeft,bottom:i.bottomSpacing,width:i.sidebarWidth};break;case"CONTAINER-BOTTOM":case"VIEWPORT-UNBOTTOM":var n=this._getTranslate(0,i.translateY+"px");e.inner=n?{transform:n}:{position:"absolute",top:i.translateY,width:i.sidebarWidth}}switch(t){case"VIEWPORT-TOP":case"VIEWPORT-BOTTOM":case"VIEWPORT-UNBOTTOM":case"CONTAINER-BOTTOM":e.outer={height:i.sidebarHeight,position:"relative"}}return e.outer=c.extend({height:"",position:""},e.outer),e.inner=c.extend({position:"relative",top:"",left:"",bottom:"",width:"",transform:""},e.inner),e}}},{key:"stickyPosition",value:function(t){if(!this._breakpoint){t=this._reStyle||t||!1,this.options.topSpacing,this.options.bottomSpacing;var e=this.getAffixType(),i=this._getStyle(e);if((this.affixedType!=e||t)&&e){var n="affix."+e.toLowerCase().replace("viewport-","")+l;for(var o in c.eventTrigger(this.sidebar,n),"STATIC"===e?c.removeClass(this.sidebar,this.options.stickyClass):c.addClass(this.sidebar,this.options.stickyClass),i.outer){var s="number"==typeof i.outer[o]?"px":"";this.sidebar.style[o]=i.outer[o]+s}for(var r in i.inner){var a="number"==typeof i.inner[r]?"px":"";this.sidebarInner.style[r]=i.inner[r]+a}var p="affixed."+e.toLowerCase().replace("viewport-","")+l;c.eventTrigger(this.sidebar,p)}else this._initialized&&(this.sidebarInner.style.left=i.inner.left);this.affixedType=e}}},{key:"_widthBreakpoint",value:function(){window.innerWidth<=this.options.minWidth?(this._breakpoint=!0,this.affixedType="STATIC",this.sidebar.removeAttribute("style"),c.removeClass(this.sidebar,this.options.stickyClass),this.sidebarInner.removeAttribute("style")):this._breakpoint=!1}},{key:"updateSticky",value:function(){var t,e=this,i=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this._running||(this._running=!0,t=i.type,requestAnimationFrame(function(){switch(t){case"scroll":e._calcDimensionsWithScroll(),e.observeScrollDir(),e.stickyPosition();break;case"resize":default:e._widthBreakpoint(),e.calcDimensions(),e.stickyPosition(!0)}e._running=!1}))}},{key:"_setSupportFeatures",value:function(){var t=this.support;t.transform=c.supportTransform(),t.transform3d=c.supportTransform(!0)}},{key:"_getTranslate",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:0,e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0,i=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0;return this.support.transform3d?"translate3d("+t+", "+e+", "+i+")":!!this.support.translate&&"translate("+t+", "+e+")"}},{key:"destroy",value:function(){window.removeEventListener("resize",this,{capture:!1}),window.removeEventListener("scroll",this,{capture:!1}),this.sidebar.classList.remove(this.options.stickyClass),this.sidebar.style.minHeight="",this.sidebar.removeEventListener("update"+l,this);var t={inner:{},outer:{}};for(var e in t.inner={position:"",top:"",left:"",bottom:"",width:"",transform:""},t.outer={height:"",position:""},t.outer)this.sidebar.style[e]=t.outer[e];for(var i in t.inner)this.sidebarInner.style[i]=t.inner[i];this.options.resizeSensor&&"undefined"!=typeof ResizeSensor&&(ResizeSensor.detach(this.sidebarInner,this.handleEvent),ResizeSensor.detach(this.container,this.handleEvent))}}],[{key:"supportTransform",value:function(t){var i=!1,e=t?"perspective":"transform",n=e.charAt(0).toUpperCase()+e.slice(1),o=document.createElement("support").style;return(e+" "+["Webkit","Moz","O","ms"].join(n+" ")+n).split(" ").forEach(function(t,e){if(void 0!==o[t])return i=t,!1}),i}},{key:"eventTrigger",value:function(t,e,i){try{var n=new CustomEvent(e,{detail:i})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,i)}t.dispatchEvent(n)}},{key:"extend",value:function(t,e){var i={};for(var n in t)void 0!==e[n]?i[n]=e[n]:i[n]=t[n];return i}},{key:"offsetRelative",value:function(t){var e={left:0,top:0};do{var i=t.offsetTop,n=t.offsetLeft;isNaN(i)||(e.top+=i),isNaN(n)||(e.left+=n),t="BODY"===t.tagName?t.parentElement:t.offsetParent}while(t);return e}},{key:"addClass",value:function(t,e){c.hasClass(t,e)||(t.classList?t.classList.add(e):t.className+=" "+e)}},{key:"removeClass",value:function(t,e){c.hasClass(t,e)&&(t.classList?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\b)"+e.split(" ").join("|")+"(\\b|$)","gi")," "))}},{key:"hasClass",value:function(t,e){return t.classList?t.classList.contains(e):new RegExp("(^| )"+e+"( |$)","gi").test(t.className)}},{key:"defaults",get:function(){return n}}]),c}());t.default=i,window.StickySidebar=i})(e)}(e={exports:{}},e.exports),e.exports),o=(i=n)&&i.__esModule&&Object.prototype.hasOwnProperty.call(i,"default")?i.default:i;t.default=o,t.__moduleExports=n,Object.defineProperty(t,"__esModule",{value:!0})});

window.wbFilterException = true;

if(window.wbAlgoliaFilter){           
  window.wbFilterException = false;
  window.$gbl_grid = (function(){return;});
  window.$gbl_grid.isotope = (function(){return;});
  window.$gbl_grid.isotope.on = (function(){return;});
  window.$gbl_grid.on = (function(){return;});
  window.$gbl_grid.data = (function(){return {};});
  window.$gbl_grid.data.items = {};
}

window.wbStickySidebar = (function () {
  var selectorSticky = '.fixed-filter-box',
      selectorStickyInner = '.fixed-filter-box .sticky-filter',
      selectorStickyContainer = '.wb-shop-collection-box',
      selectorStickyDesktop = '.wb-shop-filter-desktop.wb-shop-filter-desktop__divider';

  var sidebar;

  function isFilterVisible() {
    return window.getComputedStyle(document.querySelector(selectorStickyDesktop)).display !== 'none';
  }

  function setupResizeDetector() {
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function (entries) {
        window.wbStickySidebar.handleSizeChanged();
      });
      ro.observe(document.querySelector(selectorStickyInner));
      ro.observe(document.querySelector(selectorStickyContainer));
    } else {
      Array.prototype.slice.call(document.querySelectorAll('.wb-shop-filter__sub-heading[onclick]')).forEach(function (el) {
        el.addEventListener('click', function () {
          setTimeout(window.wbStickySidebar.handleSizeChanged, 200);   
        }, { passive: true });
      });
    }
  }

  function setup() {
    if (isMobile() || !isFilterVisible()) {
      return;
    }

    var el = document.querySelector(selectorSticky);
    var elHeader = document.getElementById('wb-hdr19');

    if (!el || !elHeader) {
      return;
    } 

    sidebar = new StickySidebar(el, { 
      containerSelector: selectorStickyContainer,
      topSpacing: elHeader.offsetHeight || 0,
      resizeSensor: false 
    });

    setupResizeDetector();
  }

  function handleSizeChanged() {
    if (!sidebar) {
      return;
    }
    sidebar.updateSticky();
  }

  return {
    setup: setup,
    handleSizeChanged: handleSizeChanged
  };
})();

window.wbShopFilter = (function () {

  var containerSelector = '.wb_shop_collection';
  var headerTopSelector = '.wb-hdr19-top';
  var shopBannerTitleSelector = '.wb-shop-banner h1[data-filter-title],.collection-title[data-filter-title]';
  var collectionHandle = window.location.pathname.replace(/\/collections\//, '')
  //Array of keyword to filters
  //Every new filter keyword gets pushed to the array when clicked active
  var filter = [];
  var filterString = '';
  var urlState = '';
  var collectionPath = '/collections/';

  var mf = Shopify.money_format.replace(/\{\{ amount[_,a-z]* \}\}/, '{{amount_no_decimals}}');
  var filterContainer = $('.wb-shop-filter-desktop.wb-shop-filter-desktop__divider');
  var activeWearFilterListSelector = '.wb-shop-filter__list';
  var activeWearFilterListDesktopSelector = '.wb-shop-filter-desktop__list';

  var mainFilterClass = $(".mainFilterClass");
  var collisionPartnerMain = $("#wb-shop-filter__main:not(.container-main-filter--mobile)");
  var collisionPartnerSub = $(".wb-shop-filter-desktop--desktop");

  var mainFilterAll = $('.wb-shop-filter-desktop [data-all="all"]');
  var filterCount = $('.filter-options-count');

  var categoryFilters = [];
  var activeFilterListEl;
  var activeFilterListDesktopEl;
  var displayActiveFilters = false;
  var ignoredFiltersFromActiveFilters = [];

  var shop_lang = window.location.pathname.split('/')[0] !== '' && window.location.pathname.split('/')[0] !== 'de' && window.location.pathname.split('/')[0] !== 'fr' ? window.location.pathname.split('/')[0].toUpperCase() : 'EN'

  var color_translation={
    EN:{black:'Black',blue:'Blue', brown:'Brown', green:'Green', grey:'Gray', pink:'Pink', purple:'Purple', red:'Red', orange: 'Orange', white:'White'},
    DE:{black:'Schwarz ',blue:'Blau ', brown:'Braun', green:'Grün', grey:'Grau', pink:'Rosa', purple:'Violett', red:'Rot', orange: 'Orange', white:'Weiß'},
    FR:{black:'Noir',blue:'Blue', brown:'Marron', green:'Vert', grey:'Gris', pink:'Rose', purple:'Violet', red:'Rouge', orange: 'Orange', white:'Blanc'},
    ME:{black:'Black',blue:'Blue', brown:'Brown', green:'Green', grey:'Gray', pink:'Pink', purple:'Purple', red:'Red', orange: 'Orange', white:'White'},
  };
  var fashion_sizes = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
  var discount_values_fashion = ['10off', '20off', '30off', '10-40off', '40off', '50off', '60off', '70off', '75off', 'bogo', 'outlet_collection', 'power-deal-may', 'deal-of-the-day', 'deal-of-the-day-1','deal-of-the-day-3', 'birthday-edition', 'power-new-colors', 'deal-of-the-day-leggings', 'deal-of-the-day-tops', 'deal-of-the-day-shorts', 'deal-of-the-day-bras'];
  var discount_values_fitness = ['basics', '10off', '20off', '30off', '10-40off','20-30off', '30-40off', '40-50off', '50off', '60off', '75off', '50-60off', '60-70off', '70-80off', 'bogo', 'deal-of-the-day-3','deal-of-the-day-4', 'deal-of-the-day-11' , 'deal-of-the-day-9'];
  var discount_translation={
    EN:{discount:'OFF',upto: 'Up to', to: 'to'},
    DE:{discount:'Rabatt',upto: 'Bis zu', to: 'bis'},
    FR:{discount:'De Réduction',upto: "JUSQU'À"},
    ME:{discount:'OFF'},
  };
 /* var discount_bogo_translation={
    EN:{bogo:'Buy 1, get 1 free'},
    DE:{bogo:'1+1 gratis'},
    FR:{bogo:'1+1 gratuit'},
    ME:{bogo:'Buy 1, get 1 free'},
  };*/
  var discount_bogo_translation={
    EN:{bogo:'2 for 1'},
    DE:{bogo:'2 für 1'},
    FR:{bogo:'Promo 2 pour 1'},
    ME:{bogo:'2 for 1'},
  };
  var discount_bs_translation={
    EN:{bs:'Deal of the Day'},
    DE:{bs:'Deal of the Day'},
    FR:{bs:'Deal of the Day'},
    ME:{bs:'Deal of the Day'},
  };
  
  /*
  if(window.location.pathname.indexOf('shop-sportswear') != -1){
    var discount_bs_translation={
      EN:{bs:'Deal of the Month'},
      DE:{bs:'Deal of the Month'},
      FR:{bs:'Deal of the Month'},
      ME:{bs:'Deal of the Month'},
    };
  }
  */
  var discount_power_translation={
    EN:{pc:'POWER NEW COLORS'},
    DE:{pc:'POWER NEW COLORS'},
    FR:{pc:'POWER NEW COLORS'},
    ME:{pc:'POWER NEW COLORS'},
  };
  var discount_bs_limited={
    EN:{le:'BIRTHDAY EDITION'},
    DE:{le:'BIRTHDAY EDITION'},
    FR:{le:'BIRTHDAY EDITION'},
    ME:{le:'BIRTHDAY EDITION'},
  };

  var urlStatePath = window.location.pathname.split('/').filter(function (p) { return p.length > 0; }).pop();
  if (window.location.pathname === '/apps/iwish') {
    urlStatePath = 'wishlist';
  }


  if (collectionHandle.indexOf('/en') > -1 && window.location.host == 'me.womensbest.com'){
    collectionHandle = collectionHandle.replace('/en','').split(/\//).shift();
    collectionPath = '/en/collections/';
  }else{
    collectionHandle = collectionHandle.split(/\//).shift();
  }
  if (urlStatePath != collectionHandle) {
    urlState = urlStatePath;
  } else {
    mainFilterAll.addClass('checked');
  }

  var priceFilter = (function () {


    var sliders = document.querySelectorAll(".range-slider input[type='range']");
    var thumbs = document.querySelectorAll(".range-slider .thumb");
    var range = document.querySelectorAll(".range-slider .range");
    var rangeValues = document.querySelectorAll(".rangeValues");
    var priceRmin = null;
    var priceRmax = null;
    var priceRangeIndex = null;
    var children = null;

    function isInitialized() {
      return sliders && sliders.length > 0;
    }

    function isPriceInRange(item) {
      return item.dataset.price >= priceRmin && item.dataset.price <= priceRmax;
    }

    function isActive () {
      if(priceRangeIndex < 2) {
        return !((priceRmin/100) == sliders[0].min && (priceRmax/100) == sliders[1].max);
      } else {
        return !((priceRmin/100) == sliders[2].min && (priceRmax/100) == sliders[3].max);
      }
    }

    function setMinMax(min, max){
      priceRmin = min;
      priceRmax = max;
    }

    function setPriceRangeText() {
      rangeValues.forEach(function(el) {
        el.innerHTML = getPriceValuesText();
      });
    }

    function getPriceValuesText() {
      var min = Shopify.formatMoney(priceRmin, mf);
      var max = Shopify.formatMoney(priceRmax, mf);
      var text = "<div>" + min + "</div>" + "<div> – </div>" + "<div>" + max + "</div>";
      return text.replace(/\s/g, '&nbsp;');
    }

    function getPriceRangeValues() {
      var slide1;
      var slide2;
      var rR;
      var rL;
      var tL;
      var tR;
      if(priceRangeIndex < 2) {
        slide1 = parseFloat( sliders[0].value * 100);
        slide2 = parseFloat( sliders[1].value * 100);
        tL     = thumbs[0].style.left;
        tR     = thumbs[1].style.left;
      } else {
        slide1 = parseFloat( sliders[2].value * 100);
        slide2 = parseFloat( sliders[3].value * 100);
        tL     = thumbs[2].style.left;
        tR     = thumbs[3].style.left;
      }
      if( slide1 > slide2 ){
        var tmpS = slide2;
        var tmpX = tR;

        slide2 = slide1;
        slide1 = tmpS;
        tR = tL;
        tL = tmpX;

        if(priceRangeIndex === 0 || priceRangeIndex === 2) {
          var left = parseInt(tR);
          $('.range').css('left', left+'%');
          $('.range').css('width', Math.abs(parseInt(tL)-left)+'%');
        } else {
          var left = parseInt(tL);
          $('.range').css('left', left+'%');
          $('.range').css('width', Math.abs(left-parseInt(tR))+'%');
        }
      }
      setMinMax(slide1, slide2);
      setPriceRangeText();
      return [slide1,slide2];
    }

    function resetPriceRangeValues(noRangeAndThumbs) {
      setMinMax(null, null);
      if (noRangeAndThumbs !== true) {
        sliders[0].value = sliders[0].min;
        sliders[1].value = sliders[1].max;
        sliders[2].value = sliders[2].min;
        sliders[3].value = sliders[3].max;

        range[0].style.left = '0%';
        range[1].style.left = '0%';
        range[0].style.width = '100%';
        range[1].style.width = '100%';

        thumbs[0].style.left = '0%';
        thumbs[2].style.left = '0%';
        thumbs[1].style.left = '100%';
        thumbs[3].style.left = '100%';
      }
      getPriceRangeValues();
      setPriceRangeText();
      document.dispatchEvent(new CustomEvent('wb:filterCallback', { detail: {filter: wbShopFilter.getFilter(), filtermin: 99999, filtermax: 99999 } }));
    }

    function handlePriceSlider(el) {
      if(!el) {return;}
      var ctx = el;
      sliders.forEach(function (s, index) {
        priceRangeIndex = index;
        if (ctx === sliders[priceRangeIndex]) {
          if (index < 2) {
            sliders[2].value = sliders[0].value;
            sliders[3].value = sliders[1].value;
          } else {
            sliders[0].value = sliders[2].value;
            sliders[1].value = sliders[3].value;
          }

          var value = (100 / (parseInt(ctx.max) - parseInt(ctx.min))) * parseInt(ctx.value) - (100 / (parseInt(ctx.max) - parseInt(ctx.min))) * parseInt(ctx.min);
          children = ctx.parentNode.childNodes[1].childNodes;
          if (index == 0 || index == 2) {
            thumbs[0].style.left = value + '%';
            thumbs[2].style.left = value + '%';
            range[0].style.left = value + '%';
            range[1].style.left = value + '%';
            range[0].style.width = Math.abs(parseInt(thumbs[1].style.left) - value) + '%';
            range[1].style.width = Math.abs(parseInt(thumbs[1].style.left) - value) + '%';
          } else {
            thumbs[1].style.left = value + '%';
            thumbs[3].style.left = value + '%';
            range[0].style.left = thumbs[2].style.left;
            range[1].style.left = thumbs[2].style.left;
            range[0].style.width = Math.abs(value - parseInt(thumbs[2].style.left)) + '%';
            range[1].style.width = Math.abs(value - parseInt(thumbs[2].style.left)) + '%';
          }
          return;
        }
      });
      getPriceRangeValues();
      //document.dispatchEvent(new CustomEvent('wb:filterCallback', { detail: {filter: wbShopFilter.getFilter(), filtermin: priceRmin, filtermax:priceRmax } }));


    }

    function init() {
      if (!isInitialized()) { return; }
      handlePriceSlider();
    }

    function getSliders() {
      return sliders;
    }

    return {
      init: init,
      isInitialized: isInitialized,
      isPriceInRange: isPriceInRange,
      isActive: isActive,
      handlePriceSlider: handlePriceSlider,
      getPriceValuesText: getPriceValuesText,
      resetPriceRangeValues: resetPriceRangeValues,
      getSliders: getSliders,
      getPriceRangeValues: getPriceRangeValues,
    };
  })();



  function animatedScrollTop() {
    return;
    var body = $('html, body');
    var collection = document.querySelector(containerSelector);
    var scrollTop = 0;
    if (collection !== null) {
      scrollTop = collection.offsetTop; 
    }
    var headerTop = document.querySelector(headerTopSelector);
    if (headerTop !== null) {
      /*if(window.screen.width < 1300) {
        scrollTop = 400;
      } else {
        scrollTop = Math.max(0, scrollTop - headerTop.clientHeight);
      }*/
      scrollTop = Math.max(0, scrollTop - headerTop.clientHeight);
    }
    if (window.scrollY < 100) {
      scrollTop = 0; 
    }
    setTimeout(function() {
      body.stop().animate({ scrollTop:scrollTop }, '225'); //800
    }, 100);
  }


  function initCategoryFilter(categories) {
    if (categories && categories.length > 0) {
      categoryFilters = categories;
    }
  }

  function isFilterListEmpty () {
    initActiveFilterEl();
    let selector = 'li:not(.hidden)';
    if (ignoredFiltersFromActiveFilters.length > 0) {
      selector += ignoredFiltersFromActiveFilters.map(f => `:not([data-id="${f}"])`).join('');
    }
    return activeFilterListEl.querySelectorAll(selector).length < 1 || activeFilterListDesktopEl.querySelectorAll(selector).length < 1;
  }

  function isCategoryInFilter(cf) {
    return filter.some(function(v) { 
      cf.includes(v);
    });
  }

  function getShopLang () {
    var l = window.location.host.split('.')[0];
    if(l === 'de' || l === 'at') {
      return 'de'.toUpperCase();
    } else if (l === 'fr') {
      return l.toUpperCase();
    } else {
      return 'EN';
    }
  }

  function appenLi(categoryFilter, f, li, checkbox, text) {
    if(activeFilterListEl.querySelectorAll('li[data-id="'+f+'"]').length > 0 || activeFilterListDesktopEl.querySelectorAll('li[data-id="'+f+'"]').length > 0) {

      var fLiList = [
        activeFilterListEl.querySelectorAll('li[data-id="'+f+'"]')[0],
        activeFilterListDesktopEl.querySelectorAll('li[data-id="'+f+'"]')[0],
      ];
      for (var fLi of fLiList) {
        fLi.addEventListener('click', function (event) {
          event.preventDefault();
          checkbox.click();
          li.remove();
          if(isFilterListEmpty()) {
            filterContainer.addClass('hidden');
            if(isCategoryInFilter(categoryFilter)) {
              mainFilterAll.addClass('checked');
            }
          }
        });
      }
      return;
    }
    if(categoryFilter.indexOf(f) == -1) {
      if (text) {
        li.appendChild(document.createTextNode(text.replace(/ *\([^)]*\) */g, "")));
      } else {
        li.appendChild(document.createTextNode(color_translation[getShopLang()][f]));
      }
      li.setAttribute('data-id', f);

      var desktopLi = li.cloneNode(true);

      var eventListener = function (event) {
        event.preventDefault();
        checkbox.click();
        li.remove();
        desktopLi.remove();
        if(isFilterListEmpty()) {
          filterContainer.addClass('hidden');
          if(isCategoryInFilter(categoryFilter)) {
            mainFilterAll.addClass('checked');
          }
        }
      };
      li.addEventListener('click', eventListener);
      desktopLi.addEventListener('click', eventListener);

      activeFilterListEl.appendChild(li);
      activeFilterListDesktopEl.appendChild(desktopLi);
      if(filterContainer.hasClass('hidden')){
        filterContainer.removeClass('hidden');
      }
    }
  }

  function initActiveFilterEl() {
    if (!activeFilterListEl) {
      activeFilterListEl = document.querySelector(activeWearFilterListSelector);
    }
    if (!activeFilterListDesktopEl) {
      activeFilterListDesktopEl = document.querySelector(activeWearFilterListDesktopSelector);
    }
  }

  function addFilterToList(f) {
    if (!displayActiveFilters) {
      return;
    }
    if (f === '*' || !f) {
      return; 
    }
    if (displayActiveFilters) {
      initActiveFilterEl();
    }
    
    if (ignoredFiltersFromActiveFilters.length > 0 && ignoredFiltersFromActiveFilters.includes(f)) {
      return;
    }

    var checkbox = $('.wb-shop-collection-box .wb-shop-filter-desktop .wb-shop-filter__wrapper label[data-id="'+f+'"]').first();
    var isHidden = checkbox.hasClass('hidden');
    if (isHidden) {
      return;
    }
    var text = checkbox.text();
    if(fashion_sizes.includes(f)) { text = f.toUpperCase(); }
    if(discount_values_fashion.includes(f) || discount_values_fitness.includes(f)) {
      if (f === '10-40off') {
        text = discount_translation[getShopLang()]['upto'] + ' ' + f.replace('10-', '').replace('off', '% ' + discount_translation[getShopLang()]['discount']);
      } else if (f.includes("off")) {
        text = (parseInt(f.replace('off', '')) - 10) + '%' + ' ' + discount_translation[getShopLang()]['to'] + ' ' + f.replace('off', '% ' + discount_translation[getShopLang()]['discount']);
        if (f === '70off') {
          text = (parseInt(f.replace('off', '')) - 10) + '%' + ' ' + discount_translation[getShopLang()]['to'] + ' ' + '80' + f.replace('70off', '% ' + discount_translation[getShopLang()]['discount']);
        }
      }
      switch (text) {
        case 'bogo':
          text = discount_bogo_translation[getShopLang()]['bogo'];
          break;
        case 'deal-of-the-day-1':
          text = discount_bs_translation[getShopLang()]['bs'];
          break;
        case 'deal-of-the-day-4':
          text = discount_bs_translation[getShopLang()]['bs'];
          break;
        case 'deal-of-the-day-3':
          text = discount_bs_translation[getShopLang()]['bs'];
          break;
        case 'deal-of-the-day-2':
          text = discount_bs_translation[getShopLang()]['bs'];
          break;
        case 'deal-of-the-day-5':
          text = discount_bs_translation[getShopLang()]['bs'];
          break;
        case 'deal-of-the-day-6':
          text = discount_bs_translation[getShopLang()]['bs'];
          break;
        case 'deal-of-the-day-7':
          text = discount_bs_translation[getShopLang()]['bs'];
          break;
        case 'deal-of-the-day-9':
          text = discount_bs_translation[getShopLang()]['bs'];
          break;
        case 'deal-of-the-day-10':
          text = discount_bs_translation[getShopLang()]['bs'];
          break;
        case 'outlet_collection':
          text = 'Outlet'
          break;
        case 'power-deal-may':
          text = 'Power Special'
          break;
        case 'power-new-colors':
          text = discount_bs_translation[getShopLang()]['pc'];
          break;
        case 'birthday-edition':
          text = discount_bs_limited[getShopLang()]['le'];
          break;
      }
    }

    var li = document.createElement('li');
    appenLi(categoryFilters, f, li, checkbox, text);

  }

  function getFilteredItemCount() {
    if(!window.wbFilterException){return;}
    return window.$gbl_grid.data('isotope').filteredItems.filter(function(item) {
      return !item.element.classList.contains('wb-shop-grid__item--ad');
    }).length; 
  }

  function appendFilter(f) { 
    if (!f) {
      return;
    }
    if (filter.includes(f)) {
      return;
    }
    filter.push(f); 
    addFilterToList(f);
    return filter;
  }

  function appendFilterString(fs) { 
    if (fs) {
      filterString += fs; 
    }
    return filterString;
  }

  function getFirstFilterStringPart() {
    var parts = filterString.split('.').filter(function (part) { return part.trim().length > 0; });
    if (parts.length === 1) {
      return parts[0]; 
    }
    return null;
  }

  function updateShopBannerTitle() {
    var shopBannerTitle = Array.prototype.slice.call(document.querySelectorAll(shopBannerTitleSelector));
    if (shopBannerTitle.length < 1) {
      return;
    }
    var isNutrition = collectionHandle === 'shop-fitness';
    if (isNutrition) {
      shopBannerTitle = shopBannerTitle.filter(function (el) {
        return !el.classList.contains('collection-title');
      });
    }
    if (shopBannerTitle.length < 1) {
      return;
    }
    var filterPart = getFirstFilterStringPart();

    if (filterPart == 'best-seller') {
      return;
    }
    if (filterPart) {
      var label = document.querySelector('.wb-shop-filter__checkbox[data-id="'+filterPart+'"]');
      if (label && label.hasAttribute('data-banner-title')) {
        var langFilterText = label.innerText;
        shopBannerTitle.forEach(function (sbt) {
          sbt.innerHTML = langFilterText;
        });
      }
    } else {
      shopBannerTitle.forEach(function (sbt) {
        sbt.innerHTML = sbt.getAttribute('data-initial-content');
      });
    }
  }

  function countItems(){
    var filteredItems = getFilteredItemCount();
    if(window.wbAlgoliaFilter){ 
      // $('.filter-result-count').text('('+wbShopFilter.getFilter().length+')');
      //$('.filter-result-count-desk').text(wbShopFilter.getFilter().length);
    }else{
      $('.filter-result-count').text('('+filteredItems+')');
      $('.filter-result-count-desk').text(filteredItems);
    }
    window.wbShopFilter.updateOptionsCount();
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      $('.wb-filter-sidebar-wrapper .wb-side-filter-footer').css('bottom','50px;');
    }
  };

  function removeFilter(key){ 

    var index = filter.indexOf(key);
    if (index > -1) {
      filter.splice(index, 1);
    }
    //document.dispatchEvent(new CustomEvent('wb:filterCallback', { detail: {filter:filter}}));
    if(isFilterListEmpty()) {
      filterContainer.addClass('hidden');
      if(isCategoryInFilter(categoryFilters)) {
        mainFilterAll.addClass('checked');
      }
    }
  }

  function isChecked($this){
    if ($this.hasClass('checked')) {
      return true;
    } else {
      return false
    }
  }

  function setFilter(f) {  
    filter = [];
    for (var i = 0; i < f.length; i++) {
      appendFilter(f[i]); 
    }
    //document.dispatchEvent(new CustomEvent('wb:filterCallback', { detail: {filter:filter}}));
  }

  var shopBannerCache = {};

  function updateShopFitnessBanner(category) {
    return;
    if($('.container--shop-borderless-banner').hasClass('stparticksday')){
      //return;
    }
    if (!category) { category = ''; }
    var oldBanner = document.querySelector('.wb-content > .container.container--shop');
    if (!oldBanner) { return; }
    if (shopBannerCache[category]) {
      $(oldBanner).replaceWith(shopBannerCache[category]);
      updateShopBannerTitle();
      return; 
    }
    axios.get('/collections/shop-fitness/' + category + '?view=fitness-ajax-banner').then(function(response) {
      shopBannerCache[category] = response.data;
      $(oldBanner).replaceWith(response.data);
      updateShopBannerTitle();
    });
  }

  function getFilteredItemsWithouPrice() {
    var filters = window.wbShopFilter.getFilter();
    if(!window.wbFilterException){
      return {};
    }
    return window.$gbl_grid.data('isotope').items.filter(function (item) {
      if (item.element.classList.contains('wb-shop-grid__item--ad')) {
        return false;
      }
      return filters.length === 0 || filters.map(function (f) {
        return item.element.classList.contains(f);
      }).reduce(function(res, value) {
        return res && value;
      }, true);
    });
  }

  function updateMinMaxPriceFromFilteredItems() {
    return;

    var minPrice;
    var maxPrice;
    getFilteredItemsWithouPrice().forEach(function (item) {
      var price = parseInt(item.element.dataset.price);
      if (isNaN(price)) {
        return;
      }
      price = price / 100;
      if (typeof minPrice === 'undefined') {
        minPrice = Math.floor(price);
      }
      if (typeof maxPrice === 'undefined') {
        maxPrice = Math.ceil(price); 
      }
      if (price < minPrice) {
        minPrice = Math.floor(price);
      }
      if (price > maxPrice) {
        maxPrice = Math.ceil(price); 
      }
    });
    setPriceMinMaxValues(minPrice, maxPrice);
  }


  function filterCallback (isReapitedCall = false) {  //edit
    countItems();
    updateShopBannerTitle();
    updateMinMaxPriceFromFilteredItems();
    algoliaFilterTracking('collectionFilter',filter);
    if(collectionHandle == 'shop-fitness') {
      var id = mainFilterClass.find('.checked').data('id');
      if(categoryFilters.indexOf(id) != -1) {
        updateShopFitnessBanner(id);
      }
    }

    var filterPart = getFirstFilterStringPart();
    if (filterPart) {
      //console.log('f 1');
      $('.collection-headline span.collection-head-subtext').show();
      let newPathname = collectionPath + collectionHandle + '/' + filterPart;
      if (window.location.pathname !== newPathname && !window.location.pathname.includes('/apps/iwish')) {
        window.history.pushState(filterPart, '', newPathname);
      }
      var langFilterText = $('.wb-shop-filter__checkbox.'+filterPart).first().text();
      $('.collection-headline span.collection-head-subtext').text(langFilterText); 
    } else {
      //console.log('f 2');
      $('.collection-headline span.collection-head-subtext').hide();
      let newPathname = collectionPath + collectionHandle;
      if (window.location.pathname !== newPathname && !window.location.pathname.includes('/apps/iwish')) {
        window.history.pushState(collectionHandle, '', newPathname);
      }
    }

    var shopGridFitness = document.querySelector('.wb-shop-grid--shop-fitness');
    if(shopGridFitness && shopGridFitness.style.display == 'none'){
      shopGridFitness.style.display='block';
    }
   if(!isReapitedCall){
    document.dispatchEvent(new CustomEvent('wb:filterCallback', { detail: {filter:filter}}));
   }

  }

  function filterItems(el) {
    if(filterString) {
      return filter.every(function(f) {
        return el.classList.contains(f);
      }) && priceFilter.isPriceInRange(el);
    } else {
      return priceFilter.isPriceInRange(el);
    }
  }

  function handleCheckboxClick($checkboxes, filterValues, e) {
    var $id = $(this).attr('data-id');
    var $this = $('.wb-shop-filter-desktop .wb-shop-filter__wrapper label[data-id="'+$id+'"]');
    var isAll = false;

    //Srcoll top after Filter Selection
    animatedScrollTop();


    if($this.length < 1) {
      //$this = $('.wb-shop-filter-desktop .wb-shop-filter__wrapper label[data-all]');
      isAll = true;
    }
    if ($checkboxes && filterValues) {
      if ($checkboxes.hasClass('checked')) {
        filter = jQuery.grep(filter, function(item) {
          return !filterValues.includes(item) && item;
        });
      }
    }
    //Handle the 'checked' class on the filter labels
    if (isChecked($this)) {
      $this.removeClass('checked');
      $('.wb-shop-filter__list li[data-id="'+$id+'"]').remove();
      $('.wb-shop-filter-desktop__list li[data-id="'+$id+'"]').remove();
      removeFilter($id);
      $('.wb-filter-string').text('');
      if(categoryFilters.includes($id)){
        mainFilterAll.addClass('checked');
      }
    } else {
      if ($checkboxes) {
        $checkboxes.removeClass('checked');
        $checkboxes.each(function (index, checkbox) {
          $('.wb-shop-filter__list li[data-id="'+checkbox.getAttribute('data-id')+'"]').remove();
          $('.wb-shop-filter-desktop__list li[data-id="'+checkbox.getAttribute('data-id')+'"]').remove();
        });
      }
      $('.wb-filter-string').text('');
      $this.addClass('checked');

      appendFilter($id);
    }

    if(isAll) {
      mainFilterAll.addClass('checked');
    }

    setTimeout(function() {
      if (filter) {
        filterString = '';
        var l = filter.length;
        filter.forEach(function(item, index) {
          appendFilterString('.' + item);
        });

        if(!window.wbFilterException){
          var categoryFitnessFilter = ['sports-nutrition','beauty-nutrition','snacks-and-functional-food','health-wellness-vitamins','energy-drinks'];
          var t = categoryFitnessFilter.filter(function(f,i){
            if(filter.indexOf(f) != -1){
              return true;
            }
          });
          if(t.length == 0){
            //document.dispatchEvent(new CustomEvent('wb:filterCallback', { detail: {filter:filter}}));
          }
        }
        //Filter the Grid
        if (filterString) {
          if(priceFilter.isActive()) {
            $gbl_grid.isotope({
              filter: function() {
                var item = this;
                return filter.every(function(f) {
                  return item.classList.contains(f);
                }) && priceFilter.isPriceInRange(item);
              }
            });
          } else {
            $gbl_grid.isotope({
              filter: filterString
            });
          }
        } else {
          if(priceFilter.isActive()) { 
            $gbl_grid.isotope({
              filter: function() { 
                return priceFilter.isPriceInRange(this);
              }
            });
          } else {
            $gbl_grid.isotope({
              filter: '*'
            });
          }
        }
      } else {
        if(priceFilter.isActive()) { 
          $gbl_grid.isotope({
            filter: function() { 
              return priceFilter.isPriceInRange(this);
            }
          });
        } else {
          $gbl_grid.isotope({
            filter: '*'
          });
        }
      }
      filterCallback();

      if (isChecked($this)) {
      scrollElementIntoViewIfNeeded($id, (e && e.target.parentElement || this));
      } else if (isChecked(mainFilterAll)) {
        var mainFilterAll2 = $('#wb-shop-filter__main .wb-shop-filter-desktop [data-all="all"]');
        scrollElementIntoViewIfNeeded(mainFilterAll2.data('all') || mainFilterAll2.data('id'), mainFilterAll2.get(0));
      }
    }, 200);

    function getFilters(input) {
      let filters = {};
      if (window.location.pathname.includes('shop-fitness')) {
        let filterSettings = window.filterSettingsNutrition;

        filters = {
          category: null,
          discount: null,
          type: null,
          other: null,
        };
        input.forEach(item => {
          if (filterSettings.category.includes(item)) {
            filters.category = item;
          } else if (filterSettings.discount.includes(item)) {
            filters.discount = item;
          } else if (filterSettings.type.includes(item)) {
            filters.type = item;
          } else if (filterSettings.other.includes(item)) {
            filters.other = item;
          }
        });
      } else if (window.location.pathname.includes('shop-sportswear')) {
        let filterSettings = window.filterSettingsFashion;

        filters = {
          size: null,
          color: null,
          category: null,
          discount: null,
          collection: null,
          other: null,
          leg_length: null,
          sleeve_length: null,
        };
        input.forEach(item => {
          if (filterSettings.size.includes(item)) {
            filters.size = item;
          } else if (filterSettings.color.includes(item)) {
            filters.color = item;
          } else if (filterSettings.discount.includes(item)) {
            filters.discount = item;
          } else if (filterSettings.collection.includes(item)) {
            filters.collection = item;
          } else if (filterSettings.category.includes(item)) {
            filters.category = item;
          } else if (filterSettings.other.includes(item)) {
            filters.other = item;
          } else if (filterSettings.leg_length.includes(item)) {
            filters.leg_length = item;
          } else if (filterSettings.sleeve_length.includes(item)) {
            filters.sleeve_length = item;
          }
        });
      } else {
        let filterSettings = window.filterSettingsAll;

        filters = {
          category: null,
          other: null,
        };
        input.forEach(item => {
          if (filterSettings.category.includes(item)) {
            filters.category = item;
          } else if (filterSettings.other.includes(item)) {
            filters.other = item;
          }
        });
      }
      return {filters};
    }


 Shopify.analytics.publish("filter_applied_custom", 	getFilters(filter));
 //console.log(getFilters(filter));

    
  }

  function updatePriceMinMax(slider, min, max) {
    if (typeof slider.dataset.min === 'undefined') {
      slider.dataset.min = slider.min;
    }
    if (typeof slider.dataset.max === 'undefined') {
      slider.dataset.max = slider.max;
    }

    //     var xMin = parseInt(priceRmin/100);
    //     var xMax = parseInt(priceRmax/100);
    //     if (isPriceFilterSet()) {
    //       if (typeof min !== 'undefined' && xMin < min) {
    //         min = xMin;
    //       }
    //       if (typeof max !== 'undefined' && xMax > max) {
    //         max = xMax;
    //       }
    //     }

    slider.min = typeof min !== 'undefined' ? min : slider.dataset.min;
    slider.max = typeof max !== 'undefined' ? max : slider.dataset.max;
    if (parseInt(slider.value) < parseInt(slider.min)) {
      slider.value = slider.min; 
    } else if (parseInt(slider.value) > parseInt(slider.max)) {
      slider.value = slider.max; 
    }
  }

  function getSlideValue(slide) {
    return (100/(parseInt(slide.max)-parseInt(slide.min)))*parseInt(slide.value)-(100/(parseInt(slide.max)-parseInt(slide.min)))*parseInt(slide.min);
  }

  function updateThumbsAndRanges(min, max) {
    for (var i = 0; i < thumbs.length; i+=2) {
      var thumb1 = thumbs[i];
      var thumb2 = thumbs[i + 1];
      thumb1.style.left = min+'%';
      thumb2.style.left = max+'%';
    }
    for (var i = 0; i < range.length; i++) {
      range[i].style.left = min+'%';
      range[i].style.width = Math.abs(max-min)+'%';
    } 
  }

  function setPriceMinMaxValues(min, max) {
    if (typeof min !== 'undefined' && typeof max !== 'undefined' && sliders[0].min == min && sliders[0].max == max) {
      return; 
    }

    for (var i = 0; i < sliders.length; i+=2) {
      var slide1 = sliders[i];
      var slide2 = sliders[i + 1];
      updatePriceMinMax(slide1, min, max);
      updatePriceMinMax(slide2, min, max);
      if (parseInt(slide1.value) == parseInt(slide2.value)) {
        slide1.value = slide1.min;
        slide2.value = slide2.max;
      }
      updateThumbsAndRanges(getSlideValue(slide1), getSlideValue(slide2));
    }
    var rangeValues = document.querySelectorAll(".rangeValues");
    setPriceRangeValues(rangeValues, true);
  }

  function resetPriceRangeValues(noRangeAndThumbs) {
    var labelLi = document.querySelector(".wb-shop-filter__list li[data-pricerange]");
    var labelLiDesktop = document.querySelector(".wb-shop-filter-desktop__list li[data-pricerange]");
    if (labelLi) {
      labelLi.remove();
    }
    if (labelLiDesktop) {
      labelLiDesktop.remove();
    }

    priceFilter.resetPriceRangeValues(noRangeAndThumbs)
    if(isFilterListEmpty()) {
      filterContainer.addClass('hidden');
    }
  }

  function updateOptionsCount() {
    var t = filter.length;
    if(priceFilter.isActive()) {

      t += 1;
    }
    if(window.wbAlgoliaFilter){
      t = wbShopFilter.getFilter().length;
      if(window.wbAlgolia.priceRangeString != '' && window.wbAlgolia.priceRangeString != undefined){
        t = wbShopFilter.getFilter().length + 1;
      }
      
    }

    // if (!window.wbShopSort.isDefaultOptions()) {
    //     t+= 1;
    //   }
    
    filterCount.text(t > 0 ? '(' + t + ')' : ''); 

    countActiveFiltersInWrapper();
  }

  function handlePriceSlider(sliders, rangeValues, event){
    priceFilter.handlePriceSlider(this);
    var text = priceFilter.getPriceValuesText(); 
    var labelLi = document.querySelector(".wb-shop-filter__list li[data-pricerange]");
    var labelLiDesktop = document.querySelector(".wb-shop-filter-desktop__list li[data-pricerange]");
    if(labelLi || labelLiDesktop) {
      if(priceFilter.isActive()) {
        if (labelLi) { labelLi.innerHTML = text; }
        if (labelLiDesktop) { labelLiDesktop.innerHTML = text; }
      } else {
        resetPriceRangeValues(true);
      }
    } else  {
      var li = document.createElement('li');
      li.setAttribute('data-pricerange', true);
      li.innerHTML = text;

      var desktopLi = li.cloneNode(true);

      var eventListener = function (event) {
        event.preventDefault();
        resetPriceRangeValues();
        
        window.$gbl_grid.isotope({
          filter: function() {
            var item = this;
            return filter.every(function(f) {
              return item.classList.contains(f);
            });
          }
        });
      };
      li.addEventListener('click', eventListener);
      desktopLi.addEventListener('click', eventListener);

      if (displayActiveFilters && !activeFilterListEl) {
        activeFilterListEl = document.querySelector(activeWearFilterListSelector);
      }
      if (displayActiveFilters && !activeFilterListDesktopEl) {
        activeFilterListDesktopEl = document.querySelector(activeWearFilterListDesktopSelector);
      }
      if(priceFilter.isActive()) {
        activeFilterListEl.appendChild(li);
        activeFilterListDesktopEl.appendChild(desktopLi);
        if(filterContainer.hasClass('hidden')){
          filterContainer.removeClass('hidden');
        }
      }
    } 
    updateOptionsCount();
  }

  function appendListItemToList(item, desktopItem) {
    if (displayActiveFilters && !activeFilterListEl) {
      activeFilterListEl = document.querySelector(activeWearFilterListSelector);
    }
    if (displayActiveFilters && !activeFilterListDesktopEl) {
      activeFilterListDesktopEl = document.querySelector(activeWearFilterListDesktopSelector);
    }
    activeFilterListEl.appendChild(item);
    activeFilterListDesktopEl.appendChild(desktopItem);
    if(filterContainer.hasClass('hidden')){
      filterContainer.removeClass('hidden');
    }
  }

  jQuery(document).ready( function($){

    mf = Shopify.money_format.replace(/\{\{ amount[_,a-z]* \}\}/, '{{amount_no_decimals}}');
    sliders = document.querySelectorAll(".range-slider input[type='range']");
    thumbs = document.querySelectorAll(".range-slider .thumb");
    range = document.querySelectorAll(".range-slider .range");
    var rangeValues = document.querySelectorAll(".rangeValues");
    priceRmin = null;
    priceRmax = null;
    priceRangeIndex = null;
    children = null;

    var mobileMainFilter = document.querySelector(".wb-shop-filter-desktop__divider-category-mobile");

    document.querySelectorAll('.wb-shop-filter-desktop__divider-category-mobile').forEach(function(el) {
      var drag = { active: false, startX: 0, sl: 0, moved: false };
      el.addEventListener('mousedown', function(e) {
        if (el.scrollWidth <= el.clientWidth) return;
        drag.active = true;
        drag.moved = false;
        drag.startX = e.clientX;
        drag.sl = el.scrollLeft;
        el.style.cursor = 'grabbing';
        el.style.userSelect = 'none';
        e.preventDefault();
      });
      document.addEventListener('mousemove', function(e) {
        if (!drag.active) return;
        var dx = e.clientX - drag.startX;
        if (Math.abs(dx) > 3) drag.moved = true;
        el.scrollLeft = drag.sl - dx;
      });
      document.addEventListener('mouseup', function() {
        if (!drag.active) return;
        drag.active = false;
        el.style.cursor = '';
        el.style.userSelect = '';
      });
      el.addEventListener('click', function(e) {
        if (drag.moved) {
          e.preventDefault();
          e.stopImmediatePropagation();
          drag.moved = false;
        }
      }, true);
    });

    if(priceFilter && window.wbFilterException){
      priceFilter.init();
    }

    var sliders = priceFilter.getSliders();
    sliders.forEach(function(el){
      el.addEventListener('input', handlePriceSlider.bind(el, sliders, rangeValues));
      el.addEventListener('mouseup', function() {
        animatedScrollTop();
        //Filter the Grid
        if(filterString){
          window.$gbl_grid.isotope({
            filter: function() {
              var item = this;
              return filter.every(function(f) {
                return item.classList.contains(f);
              }) && priceFilter.isPriceInRange(item);
            }
          });
        } else {
          window.$gbl_grid.isotope({
            filter: function() { 
              return priceFilter.isPriceInRange(this);
            }
          });
        }

        document.dispatchEvent(new CustomEvent('wb:filterCallback', { detail: {filter: wbShopFilter.getFilter(), filtermin: priceFilter.getPriceRangeValues()[0], filtermax:priceFilter.getPriceRangeValues()[1] } }));

        filterCallback(true);
      });
      el.addEventListener('touchend', function() {
        animatedScrollTop();
        //Filter the Grid
        if(filterString){
          window.$gbl_grid.isotope({
            filter: function() {
              var item = this;
              return filter.every(function(f) {
                return item.classList.contains(f);
              }) && priceFilter.isPriceInRange(item);
            }
          });
        } else {
          window.$gbl_grid.isotope({
            filter: function() { 
              return priceFilter.isPriceInRange(this);
            }
          });
        }

        document.dispatchEvent(new CustomEvent('wb:filterCallback', { detail: {filter: wbShopFilter.getFilter(), filtermin: priceFilter.getPriceRangeValues()[0], filtermax:priceFilter.getPriceRangeValues()[1] } }));

        filterCallback();
      });
    });
    if(window.wbFilterException){
      handlePriceSlider();
    }
    if(mobileMainFilter) {
      mobileMainFilter.querySelectorAll('label').forEach(function(el){
        el.addEventListener('touchstart', function(){
          el.classList.add("touched");
        });
        el.addEventListener('touchend', function(){
          el.classList.remove("touched");
        });
      });
    }

    var $p_filter_desktop_reset = $('.wb-shop-filter__delete-heading');
    var $p_filter_mobile = $('.wb-shop-tabs-mobile');

    //DELETE FILTER STRING ITEMS (MOBILE)
    $('.wb-filter-string').on('click', '.item', function(e){

      var item_id = $(this).attr('data-id');
      var item_index = filter.indexOf(item_id);

      //Srcoll top after Filter Selection
      animatedScrollTop();

      $(e.target).remove();
      filter.splice(item_index, 1);

      $('.'+item_id).removeClass('checked');

      //console.log('.'+item_id);

      filterString = "";
      var l = filter.length;

      filter.forEach(function(item,index){

        appendFilterString('.' + item);

        //add items to filter string 
        var item_string = item.match(/[^_]+$/);
      });

      //Filter the Grid
      if(filterString){
       
        window.$gbl_grid.isotope({
          filter: function() {
            var item = this;
            return filter.every(function(f) {
              return item.classList.contains(f) && priceFilter.isPriceInRange(item);
            });
          }
        });
      }
      else {
        window.$gbl_grid.isotope({
          filter: function() { 
            return priceFilter.isPriceInRange(this);
          }
        });
      }

      filterCallback();
    });

    //Handle Reset
    $p_filter_desktop_reset.click( function(e){
      e.preventDefault();
      
      let ignoredFiltersSelector = '';
      if (ignoredFiltersFromActiveFilters.length > 0) {
        ignoredFiltersSelector += ':not(.hidden)';
        ignoredFiltersSelector += ignoredFiltersFromActiveFilters.map(f => `:not([data-id="${f}"])`).join('');
      }
      $('.wb-shop-filter__wrapper label'+ignoredFiltersSelector).removeClass('checked');
      $('.wb-filter-string').text('');
      $('.wb-shop-filter__list li'+ignoredFiltersSelector).remove();
      $('.wb-shop-filter-desktop__list li').remove();
      $('.wb-shop-filter-desktop.wb-shop-filter-desktop__divider').toggleClass('hidden');
      if (ignoredFiltersFromActiveFilters.length > 0) {
        let activeFilterIds = Array.prototype.slice.call(document.querySelectorAll('.wb-shop-filter__wrapper label[data-id].checked')).map(e => e.dataset.id);
        filterString = activeFilterIds.join(' ');
        setFilter(activeFilterIds);
      } else {
        filterString = '';
        setFilter([]);
      }
      resetPriceRangeValues();
      window.$gbl_grid.isotope({
        filter: '*',
        sortBy: 'order',
        sortAscending: true
      });
      mainFilterAll.addClass('checked');

      countActiveFiltersInWrapper();
      
      animatedScrollTop();
     
      if(window.wbFilterException){
        filterCallback();
      }
    });
    $p_filter_mobile.find('li a').click( function(e){
      e.preventDefault();

      var id = $(this).attr('data-id');

      if(id == 'all'){
        window.$gbl_grid.isotope({
          filter: '*'
        });
      }
      else {
        window.$gbl_grid.isotope({
          filter: '.' + id
        });
      }
      $p_filter_mobile.find('li').removeClass('active');
      $(this).parent().addClass('active');
      filterCallback();
    });

    window.$gbl_grid.isotope({ sortBy: "order" , sortAscending: true});

    //h1 adjustment on page load
    var filterPart = getFirstFilterStringPart();
    if (filterPart) {
      $('.collection-headline span.collection-head-subtext').show();
      let newPathname = collectionPath + collectionHandle + '/' + filterPart;
      if (window.location.pathname !== newPathname && !window.location.pathname.includes('/apps/iwish')) {
        window.history.pushState(filterPart, '', newPathname);
      }
      var langFilterText = $('.wb-shop-filter__checkbox.'+filterPart).first().text();
      $('.collection-headline span.collection-head-subtext').text(langFilterText); 
    }

  });

  function initUrlFilter() {
    window.$gbl_grid.on( 'arrangeComplete', function( event, filteredItems ) {
      $('.filter-result-count-desk').text(window.wbShopFilter.getFilteredItemCount());
      wbShopFilter.countCategories(categoryFilters);

      setTimeout(function(){ 
        if(filteredItems.length != 0 ){
          $('.wb-filter_no-results').hide();
        } else {
          $('.wb-filter_no-results').show();
        }
      }, 1000);
    });
    if(collectionHandle != 'shop-fitness' && collectionHandle != 'shop-sportswear' && window.wbFilterException) {
      window.$gbl_grid.isotope().on( 'layoutComplete', function( event, filteredItems ) {
        //
      });
    }
    if (urlState.length === 0) {
      return; 
    }
    var checkbox = $('.wb-shop-collection-box .wb-shop-filter-desktop .wb-shop-filter__wrapper label[data-id="'+urlState+'"]').first();
    if (urlState.length === 0) {
      return; 
    }

    if (urlState != collectionHandle && checkbox.length !== 0) {
      if (urlState == 'all') {
        // window.$gbl_grid.isotope({
        //   filter: '*'
        // });
      } else {
        setFilter([urlState]);
        filterString = '.' + urlState;
        window.wbShopFilter.updateShopBannerTitle();
        
        // window.$gbl_grid.isotope({
        //   filter: '.' + urlState,
        //   sortBy: "order" ,
        //   sortAscending: true,
        //   transitionDuration: 0
        // });
        if(categoryFilters.indexOf(urlState) == -1) {
          mainFilterAll.addClass('checked');
        }
        $('.wb-shop-filter-desktop [data-id="'+urlState+'"]').addClass('checked');
        // window.$gbl_grid.isotope({transitionDuration: 400}); // It was a comment
        scrollElementIntoViewIfNeeded(urlState, mainFilterAll.get(0));
      }
    } else {
      //mainFilterAll.addClass('checked');
    }
    if(window.wbShopFilter.getFilter().length > 0) {
      if(!$('.wb-shop-filter__checkbox-category_all').hasClass('checked') && window.location.pathname.split('/').splice(-1)[0].split('+').length > 1){
        filterCount.text(filter.length > 0 ? '(' + (filter.length + 1) + ')' : '');
      }else {
        filterCount.text(filter.length > 0 ? '(' + filter.length + ')' : '');
      }
    }

    countActiveFiltersInWrapper();
  }

  function countFilteredItems(list, filter) {
    if(list) {
      if(filter){
        list.filter(function (f) {
          return f !== filter;
        });
      }
    }
    var filters = window.wbShopFilter.getFilter().filter(function (f) { return list.indexOf(f) === -1 && f !== filter; });

    if(!window.wbFilterException){
      return {};
    }
    return window.$gbl_grid.data('isotope').items.filter(function (item) {
      if (item.element.classList.contains('wb-shop-grid__item--ad')) {
        return false;
      }
      var isItemFiltered = filters.length === 0 || filters.map(function (f) {
        return item.element.classList.contains(f);
      }).reduce(function(res, value) {
        return res && value;
      }, true) && priceFilter.isPriceInRange(item.element);

      if (isItemFiltered && !filter && priceFilter.isPriceInRange(item.element)) {
        return true; 
      }
      return isItemFiltered && filter && item.element.classList.contains(filter) && priceFilter.isPriceInRange(item.element);
    }).length;
  }

  function setCategoryCountResultText (list) {
    list.forEach(function(f) {
      var rText = countFilteredItems(list, f); 
      var label = $('.filter-result-'+f).closest('label');
      if(!label.hasClass('checked')) {
        if(rText == 0){
          if(!label.hasClass('hidden')) {
            label.addClass('hidden');
          }
        } else {
          if(label.hasClass('hidden')) {
            label.removeClass('hidden');
          }
        }
      }

      $('.filter-result-'+f).text('('+ rText +')');
    });
  }

  function countCategories(list){
    var filteredItems = countFilteredItems(list);
    $('.filter-result-all').text('('+filteredItems+')');
    setCategoryCountResultText(list);
    setTimeout(function () {
      scrollElementIntoViewIfNeeded(urlState, document.querySelector('.wb-shop-filter-desktop label.wb-shop-filter__checkbox-range.checked'));
    }, 100);
  }

  function collision() {
    var y1 = collisionPartnerMain.offset().top;
    var y2 = collisionPartnerSub.offset().top;
    var h2 = collisionPartnerSub.outerHeight(true) + 1;
    var b2 = y2 + h2;
    if (y1 >= (b2-h2)) return false;
    return true;
  }

  function initMainFilterClass() {
    if($('.wb-header__sidenav .wb-shop-filter__wrapper.mainFilterClass label[data-id="'+wbShopFilter.getUrlState()+'"]').length != 0){
      $('.wb-header__sidenav .wb-shop-filter__wrapper.mainFilterClass label[data-id="'+wbShopFilter.getUrlState()+'"]').addClass('checked');
    }
        
    $(window).scroll(function() {
      //var $div1 = $("#testId");
      //var $div2 = $(".wb-shop-filter-desktop--desktop");
      if(collision()) {
        mainFilterClass.removeClass("mainFilterClass--hidden");
      } else {
        if(!mainFilterClass.hasClass("mainFilterClass--hidden")) { 
          mainFilterClass.addClass("mainFilterClass--hidden");
        }
      }
    });
  }

  var _filterMobile = null;
  
  function scrollElementIntoViewIfNeeded(id, element) {
    // Mobile: scroll to first product row instead of top
    if (window.outerWidth < 1300) {
      try {
        if (!_filterMobile) {
          _filterMobile = document.querySelector('.container-main-filter.container-main-filter--mobile');
        }
        var collection = document.querySelector(containerSelector);
        if (collection) {
          var filterHeight = _filterMobile ? _filterMobile.offsetHeight : 0;
          var scrollTarget = collection.offsetTop - filterHeight;
          if (window.scrollY > scrollTarget) {
            window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
          }
        }
      } catch (e) {}
      if(categoryFilters.indexOf(id) != -1) {
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
      return;
    }
    // Desktop: scroll filter element into view
    if(categoryFilters.indexOf(id) != -1) {
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    } else {
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }

  function countActiveFiltersInWrapper() {return;
    var groupedFilters = wbShopFilter.getFilter().reduce(function (result, filter) {
        var wrapper =  document.querySelector('.wb-header__sidenav label.wb-shop-filter__checkbox[data-id="'+filter+'"').closest('.wb-shop-filter__wrapper');
        if (!result[wrapper.id]) {
            result[wrapper.id] = [];
        } 
        if (!result[wrapper.id].includes(filter)) {
            result[wrapper.id].push(filter);
        }
        return result;
    }, {});

    document.querySelectorAll('.wb-header__sidenav .wb-shop-filter__wrapper').forEach(function (el) {
      var count = el.querySelector('.wb-shop-filter__sub-heading .wb-shop-filter__filter-count');
      if (!count) {
        return;
      }
      if (el.id === 'wb-shop-filter__fashion-price') {
        // if (priceFilter.isActive()) {
        if (window.wbAlgolia.priceRangeString != '' && window.wbAlgolia.priceRangeString != undefined) {
          count.textContent = ' ('+1+')';
        } else {
          count.textContent = '';
        }
        return;
      }
      var wrapperFilters = groupedFilters[el.id] || [];
      if (wrapperFilters.length > 0) {
        count.textContent = ' ('+wrapperFilters.length+')';
      } else {
        count.textContent = '';
      }
    });
  }

  return {
    animatedScrollTop: animatedScrollTop,
    updateShopBannerTitle: updateShopBannerTitle,
    collectionHandle: collectionHandle,
    getFilter: function () {
      return filter;
    },
    setFilter: setFilter,
    appendFilter: appendFilter,
    getFilterString: function () {
      return filterString;
    },
    setFilterString: function (fs) {
      filterString = fs;
    },
    appendFilterString: appendFilterString,
    getUrlState: function () {
      return urlState;
    },
    setUrlState: function (us) {
      urlState = us;
    },
    handleCheckboxClick: handleCheckboxClick,
    filterCallback: filterCallback,
    initUrlFilter: initUrlFilter,
    enableDisplayActiveFilters: function () {
      displayActiveFilters = true;
    },
    setIgnoredFiltersFromActiveFilters: function (filters) {
      ignoredFiltersFromActiveFilters = filters;
    },
    getFilteredItemCount: getFilteredItemCount,
    initCategoryFilter: initCategoryFilter,
    getCategoryFilters: function () {
      return categoryFilters;
    },
    handlePriceSlider: handlePriceSlider,
    updateOptionsCount: updateOptionsCount,
    appendListItemToList: appendListItemToList,
    isFilterListEmpty: isFilterListEmpty,
    isCategoryInFilter: isCategoryInFilter,
    countCategories: countCategories,
    initMainFilterClass: initMainFilterClass
  };
})();

window.wbShopSort = (function () {

  var labels,
      activeClass = 'checked';

  // var data = null;

  function uncheckLabel(label) {
    label.removeClass(activeClass);
  }

  function uncheckLabels() {
    if (!labels) {
      labels =  $('.wb-sort-container label, .desktop-sort-by-dropdown label, .desktop-sort-by-dropdown a');
    }
    uncheckLabel(labels);
  }

  function updateGrid(options) {

    if(!window.wbFilterException){
      
      if(options.sortBy == 'order'){
        options = JSON.stringify(options);
      }
      options = JSON.parse(options);
      // data = options;
      document.dispatchEvent(new CustomEvent('wb:filterCallback', { detail: {filterSort: options } }));

      return;
    }

    if (typeof options === 'string') {
      options = JSON.parse(options);
      // data = options;
    }
    window.$gbl_grid.isotope(options);
  }

  function checkLabel(label) {
    label.addClass(activeClass);
    updateGrid(label.attr('data-isotope-option'));
  }

  function createListElement(self) {
    var li = document.createElement('li');
    li.setAttribute('data-sort-by', true);
    li.innerHTML = self.text();
    
    var desktopLi = li.cloneNode(true);

    var eventListener = function (event) {
      event.preventDefault();
      li.remove();
      desktopLi.remove();
      if(window.wbShopFilter.isFilterListEmpty() && window.wbShopFilter.isPriceFilterSet != undefined && !window.wbShopFilter.isPriceFilterSet()) {
        $('.wb-shop-filter-desktop.wb-shop-filter-desktop__divider').addClass('hidden');
        if(window.wbShopFilter.isCategoryInFilter(window.wbShopFilter.getFilter()[0])) {
          $('.wb-shop-filter-desktop [data-all="all"]').addClass('checked');
        }
      }
      uncheckLabels();
      checkLabel(self.parent().children().first());
    };
    li.addEventListener('click', eventListener);
    desktopLi.addEventListener('click', eventListener);

    window.wbShopFilter.appendListItemToList(li, desktopLi);
  }

  function initCheckboxes() {
    $('.wb-sort-container [data-isotope-option]').on('click', function(event) {
      event.preventDefault();
      var self = $(this);
      var elPopular = self.parent().children().first();
      var text = self.text();
      var labelLi = document.querySelector(".wb-shop-filter__list li[data-sort-by]");
      var labelLiDesktop = document.querySelector(".wb-shop-filter-desktop__list li[data-sort-by]");
      var filterContainer = $('.wb-shop-filter-desktop.wb-shop-filter-desktop__divider');

      if(labelLi || labelLiDesktop) {
        if(text !== elPopular.text()) {
          if (labelLi) { labelLi.innerHTML = text; }
          if (labelLiDesktop) { labelLiDesktop.innerHTML = text; }
        } else {
          if (labelLi) {labelLi.remove(); }
          if (labelLiDesktop) { labelLiDesktop.remove(); }
          if(window.wbShopFilter.isFilterListEmpty() && window.wbShopFilter.isPriceFilterSet != undefined && !window.wbShopFilter.isPriceFilterSet()) {
            filterContainer.addClass('hidden');
            if(window.wbShopFilter.isCategoryInFilter(window.wbShopFilter.getFilter()[0])) {
              $('.wb-shop-filter-desktop [data-all="all"]').addClass('checked');
            }
          }

          uncheckLabels();
          checkLabel(self.parent().children().first());

        }
      } else  {
        if(text !== elPopular.text()) {
         // createListElement(self);    
        } else {

        }
      } 

      if (self.hasClass(activeClass)) {
        //uncheckLabel(self);
        updateGrid({
          sortBy: 'order'
        });
      } else {
        uncheckLabels();
        checkLabel(self);
      }

      window.wbShopFilter.updateOptionsCount(); 
    });
  }

  function initDropdown() {
    $('.desktop-sort-by-dropdown [data-isotope-option]').on('click', function(event) {
      event.preventDefault();
      uncheckLabels();
      checkLabel($(this));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCheckboxes();
    initDropdown();
  }, false);

  return {
    // getOptions: () => data,
    // isDefaultOptions: () => !data || (data && data.sortBy == 'order'),
  };
})();

window.wbShopGridToggle = (function () {
  var domain = window.location.hostname.replace(/^[^.]+/g, '');

  var idDefault = 'grid-toggle-default',
      idFull = 'grid-toggle-full',
      classActive = 'grid-box-button--active',
      classGridFull = 'wb-shop-grid--full';

  var elDefault,
      elFull,
      elShopGrid;

  function onToggle(type, event) {
    if (event) {
      event.preventDefault();
    }
    if (!elShopGrid) {
      elShopGrid = document.querySelector('.wb-shop-grid');
    }
    if (type === 'default') {
      elFull.classList.remove(classActive);
      elDefault.classList.add(classActive);
      elShopGrid.classList.remove(classGridFull);
    } else if (type === 'full') {
      elDefault.classList.remove(classActive);
      elFull.classList.add(classActive);
      elShopGrid.classList.add(classGridFull);
    }

    if (window.$gbl_grid && window.$gbl_grid.length === 1) {

      window.$gbl_grid.isotope('layout');

    }
    if (window.equalHeightInstance) {
      window.equalHeightInstance.update();
    }

    Cookies.set('wb_grid_layout', type, {expires: 30, path: '/', domain: domain});
  }

  document.addEventListener('DOMContentLoaded', function () {
    elDefault = document.getElementById(idDefault);
    elFull = document.getElementById(idFull);

    if (!elDefault || !elFull) { return; }

    elDefault.addEventListener('click', onToggle.bind(elDefault, 'default'));
    elFull.addEventListener('click', onToggle.bind(elFull, 'full'));

    var type = Cookies.get('wb_grid_layout', {domain: domain});
    if (type && type !== 'default') {
      //onToggle(type, null);
    }
  }, false);

  return {

  };

})();

function applyFilterSelection() {
  window.wbHeaderSidenav.hide();
  $('.wb-header__sidenav__main').css('display', 'block');
  $('html').removeClass('wb-filtermobile--opened');
  $('html').removeClass('wb-sortmobile--opened');
  $('#wb-filter-sidebar').removeClass('visibleside');
}

document.addEventListener('DOMContentLoaded', function() {
  window.wbStickySidebar.setup();

  $('.btn-trigger-filter-mobile').click(function() {
    window.wbHeaderSidenav.show();
    $('html').toggleClass('wb-filtermobile--opened');
    $('.wb-header__sidenav__main').css('display', 'none');
    $('.wb-header__sidenav').addClass('wb-header__sidenav--open');

  });

  $('.wb-bckdrp19').click(function() {
    $('.wb-header__sidenav__main').css('display', 'block');
    $('html').removeClass('wb-filtermobile--opened');
    $('html').removeClass('wb-sortmobile--opened');
    $('.wb-header__sidenav').removeClass('wb-header__sidenav--open');
    $('#wb-filter-sidebar').removeClass('visibleside');
  });
});

(function () {
  var timeout;

  function resetTimeout() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  }

  function mouseenter (el) {
    if (!$(el).hasClass('active')) {
      return; 
    }
    resetTimeout();
  }

  function mouseleave(el, selected) { // ToDo
    if (!$(el).hasClass('active')) {
      return; 
    }
    if(!timeout) {
      timeout = setTimeout(function(){ 
        $('.wb-shop-filter-desktop--desktop ' + selected).toggle();
        $(el).toggleClass('active'); 
        $(el).parent().toggleClass('active'); 
        resetTimeout(el);
      }, 500);
    }
  }

  window.clickFilter = function(selected, el) {
    var isDesktop = $(el).parents('.wb-shop-filter-desktop--desktop').length == 1;
    var h = $('.wb-shop-collection-box .wb-shop-filter-desktop .wb-shop-filter__sub-heading');
    if (!h.length) {
      return;
    }
    resetTimeout();

    $((isDesktop ? '.wb-shop-filter-desktop--desktop ' : '.wb-header__sidenav ') + selected).toggle();
    $(el).toggleClass('active');
    $(el).parent().toggleClass('active');

    if (isDesktop) {
      h.each(function() {
        if(el == this) {return;}
        if($(this).hasClass('active')){
          $(this).next().toggle();
          $(this).toggleClass('active'); 
          $(this).parent().toggleClass('active'); 
        }
      });

      var wrapper = $(el).parent().first();
      if (wrapper.data('has-listener')) {
        return; 
      }
      wrapper.data('has-listener', true);

      var me = mouseenter.bind(null, el);
      var ml = mouseleave.bind(null, el, selected);

      $(el).mouseenter(me);
      $(el).mouseleave(ml);
      $(selected).mouseenter(me);
      $(selected).mouseleave(ml);
    }
  }
})();

(function(){
  // TODO: rewrite .active class
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|WomensBestApp/i.test(navigator.userAgent) === false) {
    $('.wb-shop-filter-desktop .wb-shop-filter__wrapper').removeClass('active');
    $('.wb-shop-filter__sub-heading').removeClass('active');
    $('.wb-shop-filter__sub-heading').next().css('display', 'none');
    $('.wb-shop-collection-box .wb-shop-filter-desktop--desktop').addClass('wb-shop-filter-desktop--ready');
  } 
})();

document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector('.container-main-filter--with-button');
  const elBtn = el.querySelector('.sort-filter-box .btn-trigger-filter-mobile');
  if (el.classList.contains('container-main-filter--always-btn') && elBtn) {
    elBtn.classList.remove('hidden');
  }
//   const observer = new IntersectionObserver( 
//     ([e]) => {
//       console.log(e.intersectionRatio);
//       // e.target.classList.toggle('container-main-filter--mobile-sticky', e.intersectionRatio < 1);
//       // e.target.querySelector('.sort-filter-box .btn-trigger-filter-mobile').classList.toggle('hidden', e.intersectionRatio >= 1);
//     },
//     { threshold: [1] }
//   );
//   observer.observe(el);
  var collectionBox = document.querySelector('.wb-shop-collection-box');
  function handleScroll () {
      if (window.outerWidth >= 1300) {
        return;
      }
      //const stickyTop = parseInt(window.getComputedStyle(el).top);
      //const currentTop = el.getBoundingClientRect().top;

      if (!el.classList.contains('container-main-filter--always-btn')) {
        elBtn.classList.toggle('hidden', window.scrollY <= el.getBoundingClientRect().bottom);
      }

      // Fade out filter when collection bottom reaches viewport bottom (footer visible)
      if (collectionBox) {
        var boxBottom = collectionBox.getBoundingClientRect().bottom;
        el.classList.toggle('container-main-filter--past-collection', boxBottom <= window.innerHeight);
      }
  }
  window.addEventListener('scroll', throttle(100, handleScroll), { passive: true });
  handleScroll();

  // Scroll the filter bar left and right a few times to draw attention
  var scrollTarget = el.querySelector('.wb-shop-filter-desktop__divider-category-mobile');
  if (scrollTarget && scrollTarget.scrollWidth > scrollTarget.clientWidth) {
    var scrollAmount = 80;

    setTimeout(function() {
      scrollTarget.scrollTo({ left: scrollAmount, behavior: 'smooth' });
      setTimeout(function() {
        scrollTarget.scrollTo({ left: 0, behavior: 'smooth' });
      }, 800);
    }, 500);
  }
});